import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "@/pages/home/components/HeroSection";
import NosotrosSection from "@/pages/home/components/NosotrosSection";
import TalentosSection from "@/pages/home/components/TalentosSection";
import EnfoquesSection from "@/pages/home/components/EnfoquesSection";
import ContactoSection from "@/pages/home/components/ContactoSection";

export default function HomePage() {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = "smooth";
    return () => {
      document.documentElement.style.scrollBehavior = "";
    };
  }, []);

  return (
    <main className="min-h-screen">
      <Navbar />
      {/* 1. Hero */}
      <HeroSection />
      {/* 2. Métricas de Autoridad + 3. Barra de Logos (ambas en NosotrosSection) */}
      <NosotrosSection />
      {/* 4. Talentos Exclusivos */}
      <TalentosSection />
      {/* 5. Servicios Detallados */}
      <EnfoquesSection />
      {/* 6. Contacto / Footer */}
      <ContactoSection />
      <Footer />
    </main>
  );
}